import React from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { adminTabs, childTabs } from '../../data/navigation';
import { AvatarMenu } from './AvatarMenu';
import { SyncStatus } from './SyncStatus';
import { TimerBar } from './TimerBar';
import { Logo } from './Logo';
export function Sidebar() {
  const {
    isAdmin,
    family,
    approvalsCount
  } = useAppState();
  const {
    tab,
    setTab,
    sub
  } = useUi();
  const tabs = isAdmin ? adminTabs : childTabs;
  return <aside className="sticky top-0 hidden h-screen w-64 shrink-0 flex-col border-r border-line bg-surface px-4 py-5 md:flex" data-id="element-903" data-mp="j6xg43ffm519">
      <div className="px-2" data-id="element-904" data-mp="nzqgyg7s4t82">
        <Logo data-id="element-905" data-mp="sxs2r8wlb6n8" />
      </div>
      <div className="mt-5 rounded-2xl bg-canvas px-3 py-2.5" data-id="element-906" data-mp="sybci2c36oq6">
        <p className="font-display text-lg font-semibold leading-tight" data-id="element-907" data-mp="xx4pltngodpt">Družina {family.name}</p>
        <p className="mt-0.5 text-xs font-semibold text-muted" data-id="element-908" data-mp="12w8w2cj03xcg">{family.sampleLabel}</p>
      </div>
      <nav aria-label="Glavna navigacija" className="mt-5" data-id="element-909" data-mp="1l0ry52gzqd41">
        <ul className="space-y-1" data-id="element-910" data-mp="1l2ctuvf1k23h">
          {tabs.map(({
          id,
          label,
          icon: Icon
        }) => {
          const active = !sub && tab === id;
          return <li key={id} data-id="element-911" data-mp="1b22fv8l6mqn9">
                <button type="button" onClick={() => setTab(id)} aria-current={active ? 'page' : undefined} className={`flex h-11 w-full items-center gap-3 rounded-2xl px-3 text-sm font-bold transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent ${active ? 'bg-accent-soft text-accent-ink' : 'text-ink hover:bg-canvas'}`} data-id="element-912" data-mp="1b3dj97aptwdu">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-913" data-mp="1pz34h382u5hi" />
                  <span className="flex-1 text-left" data-id="element-914" data-mp="2mialxjztok3o">{label}</span>
                  {id === 'pregled' && approvalsCount > 0 && <span className="rounded-full bg-accent px-2 py-0.5 text-xs font-extrabold text-white" data-id="element-915" data-mp="2hq93fgc29x57">{approvalsCount}</span>}
                </button>
              </li>;
        })}
        </ul>
      </nav>
      <div className="mt-auto space-y-3" data-id="element-916" data-mp="kufvowmkuvw4">
        <TimerBar variant="sidebar" data-id="element-917" data-mp="62nppb8oau72" />
        <div className="px-2" data-id="element-918" data-mp="61mdh3fx81nr">
          <SyncStatus data-id="element-919" data-mp="b2ihdh09vnt6" />
        </div>
        <div className="border-t border-line pt-3" data-id="element-920" data-mp="b1h373nyml78">
          <AvatarMenu placement="up" showName data-id="element-921" data-mp="3t8enrn6fhx4c" />
        </div>
      </div>
    </aside>;
}